/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { ButtonHTMLAttributes, ClassAttributes, ReactNode } from "react";

const styles = {
  root: (
    backgroundColor: string,
    borderColor: string,
    display: string,
    height: number,
    fontFamily?: string,
  ) => css`
    display: ${display};
    align-items: center;
    gap: 5px;
    vertical-align: middle;
    padding-block: 0;
    padding-inline: 8px;
    max-inline-size: 100%;
    height: ${height}px;
    line-height: 18px;
    font-weight: 500;
    font-size: 12px;
    white-space: nowrap;
    -webkit-text-decoration: none;
    text-decoration: none;
    cursor: default;
    color: black;
    background-color: ${backgroundColor};
    border: 1px solid ${borderColor};
    border-radius: 3px;
    text-align: start;
    font-family: ${fontFamily !== undefined ? fontFamily : "inherit"};
    overflow: hidden;
    text-overflow: ellipsis;
  `,
};

type BadgePlainProps = ClassAttributes<HTMLButtonElement> &
  ButtonHTMLAttributes<HTMLButtonElement> & {
    color?: string;
    borderColor?: string;
    height?: number;
    fontFamily?: string;
    children: ReactNode;
    display?: "inline-block" | "flex";
  };

export const BadgePlain = ({
  display = "inline-block",
  height = 20,
  color = "transparent",
  borderColor = "transparent",
  fontFamily,
  children,
  ...spanProps
}: BadgePlainProps) => {
  return (
    <span
      className="badge-plain"
      css={styles.root(color, borderColor, display, height, fontFamily)}
      {...spanProps}
    >
      {children}
    </span>
  );
};
